import { UserAvatar, cn } from "@nexus/ui";
import { orgColor } from "@/features/identity-hub/utils/iam.utils";
import { ORG_ACCENT_FRAME_BORDER_CLASS, orgAccentVar } from "@/features/identity-hub/utils/org-accent-surface";

const SIZE_PX = {
  sm: 24,
  md: 32,
  lg: 40,
  xl: 80,
} as const;

interface UserPhotoMarkProps {
  name: string;
  photoUrl?: string | null;
  size?: keyof typeof SIZE_PX;
  className?: string;
}

export function UserPhotoMark({
  name,
  photoUrl,
  size = "lg",
  className,
}: UserPhotoMarkProps) {
  const accent = orgColor(name);
  const dimension = SIZE_PX[size];

  if (photoUrl) {
    return (
      <div
        className={cn(
          "shrink-0 overflow-hidden rounded-full border bg-muted/20",
          ORG_ACCENT_FRAME_BORDER_CLASS,
          className,
        )}
        style={{ ...orgAccentVar(accent), width: dimension, height: dimension }}
      >
        <img
          src={photoUrl}
          alt={name}
          className="size-full object-cover"
          referrerPolicy="no-referrer"
        />
      </div>
    );
  }

  return <UserAvatar name={name} size={size} className={className} />;
}
